import { ILatLon, LatLon } from '@curbnturf/entities';
import { createAction, props } from '@ngrx/store';

export enum LocationActionTypes {
  SelectLocation = '[Location] Select Location',
  // SetViewport = '[Location] Set Viewport',
  FindCurrentLocation = '[Location] Find Current Location',
  CurrentLocationSuccess = '[Location] Find Current Location Success',
  CurrentLocationFailed = '[Location] Find Current Location Failed',
  GeocodeUserAddress = '[Location] Geocode User Address',
  GeocodeSuccess = '[Location] Geocode Success',
  GeocodeFailed = '[Location] Geocode Failed',
}

export const selectLocation = createAction(
  LocationActionTypes.SelectLocation,
  props<{ center: ILatLon; distance: number }>(),
);

// export const setViewport = createAction(
//   LocationActionTypes.SetViewport,
//   props<{ center: ILatLon; distance: number }>(),
// );

export const findCurrentLocation = createAction(
  LocationActionTypes.FindCurrentLocation,
  props<{ timeout?: number; highAccuracy?: boolean }>(),
);

export const currentLocationSuccess = createAction(
  LocationActionTypes.CurrentLocationSuccess,
  props<{ location: LatLon }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const currentLocationFailed = createAction(LocationActionTypes.CurrentLocationFailed, props<{ error: any }>());

export const geocodeUserAddress = createAction(LocationActionTypes.GeocodeUserAddress);

export const geocodeSuccess = createAction(LocationActionTypes.GeocodeSuccess, props<{ location: LatLon }>());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const geocodeFailed = createAction(LocationActionTypes.GeocodeFailed, props<{ error: any }>());
